import React from "react";
import { DocumentSubmissionDropdown } from "../../../../types/forms/DoumentSubmission";
import {
  DROPDOWN_SELECTED_VALUE,
  DROPDOWN_VALUES,
  IS_EDITABLE,
} from "../../../../constants/forms";
import { FormikValues, useFormikContext } from "formik";

type Props = {
  item: DocumentSubmissionDropdown;
  fieldName: string;
  index: number;
};

const DocumentListDropdown = (props: Props) => {
  const { item, fieldName, index } = props;

  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const documentData = [...values[fieldName]];

    documentData[index][DROPDOWN_SELECTED_VALUE] = e.target.value;
    setFieldValue(fieldName, documentData);
  };

  return (
    <>
      {item?.[DROPDOWN_VALUES] && item?.[DROPDOWN_VALUES]?.length > 0 && (
        <select
          className="form-control width-50"
          value={item?.[DROPDOWN_SELECTED_VALUE]}
          onChange={onChange}
        >
          <option value="">Select</option>
          {item?.[DROPDOWN_VALUES]?.map((item: any) => (
            <option value={item}>{item}</option>
          ))}
        </select>
      )}
    </>
  );
};

export default DocumentListDropdown;
